export default class Modal {
    constructor() {
        this.init();
    }

    init() {
        // Get all team member cards
        const teamMembers = document.querySelectorAll('[data-team-member]');

        teamMembers.forEach(member => {
            const buttons = member.querySelectorAll('button');
            const modal = member.querySelector('[data-modal]');

            if (buttons && modal) {
                // Open modal
                buttons.forEach(button => {
                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        modal.classList.remove('hidden');
                    });
                });

                // Close modal
                const closeButtons = modal.querySelectorAll('[data-modal-close]');
                closeButtons.forEach(closeButton => {
                    closeButton.addEventListener('click', (e) => {
                        e.preventDefault();
                        modal.classList.add('hidden');
                    });
                });
            }
        });

        // Close on ESC key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                const openModals = document.querySelectorAll('[data-modal]:not(.hidden)');
                openModals.forEach(modal => {
                    modal.classList.add('hidden');
                });
            }
        });
    }
}